import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import FieldGroup from './FieldGroup';
import Dropdown from './Dropdown';

const platforms = [
  "GitHub", "NoCodeBackend", "Cloudflare Pages", "Dropbox", 
  "OpenAI", "Cloudflare Env Vars", "Other"
].map(p => ({ value: p, label: p }));

function InstructionModal({ isOpen, onClose, onSave, instruction }) {
  const [formData, setFormData] = useState({
    platform: 'Other',
    title: '',
    steps: '',
    sortOrder: 10,
  });

  useEffect(() => {
    if (instruction) {
      setFormData({
        platform: instruction.platform || 'Other',
        title: instruction.title || '',
        steps: instruction.steps || '',
        sortOrder: instruction.sortOrder || 10,
      });
    } else {
      setFormData({ platform: 'Other', title: '', steps: '', sortOrder: 10 });
    }
  }, [instruction, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (e) => {
    setFormData(prev => ({ ...prev, platform: e.target.value }));
  };

  const handleSave = () => {
    const dataToSave = {
        ...formData,
        sortOrder: Number(formData.sortOrder) || 10,
    };
    onSave(dataToSave);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={instruction ? "Edit Instruction" : "Create Instruction"}>
      <div className="space-y-4">
        <FieldGroup label="Platform">
          <Dropdown options={platforms} name="platform" value={formData.platform} onChange={handleDropdownChange} />
        </FieldGroup>
        <FieldGroup label="Title">
          <input type="text" name="title" value={formData.title} onChange={handleChange} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
        </FieldGroup>
        <FieldGroup label="Steps">
          <textarea name="steps" value={formData.steps} onChange={handleChange} rows="5" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
        </FieldGroup>
        <FieldGroup label="Sort Order">
            <input type="number" name="sortOrder" value={formData.sortOrder} onChange={handleChange} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm" />
        </FieldGroup>
        <div className="flex justify-end space-x-2">
          <button onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50">Cancel</button>
          <button onClick={handleSave} className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700">Save</button>
        </div>
      </div>
    </Modal>
  );
}

export default InstructionModal;